import React from 'react';
import { Link } from 'react-router-dom';
import ExpandingTeamCard from '../components/ExpandingTeamCard';
import FooterWrapper from '../components/FooterWrapper';
import buttonarrowright from '../assets/icons/button-arrow-right.svg';
import timeline from '../assets/about/timeline.svg';
import scanSearch from '../assets/about/scan-search.svg';
import lightbulb from '../assets/about/lightbulb.svg';
import handshake from '../assets/about/handshake.svg';
import rocket from '../assets/about/rocket.svg';

const AboutMobile = () => {
  return (
    <div className="flex flex-col bg-[#070709] overflow-hidden">
      {/* Section 1: Hero */}
      <section className="min-h-screen flex flex-col items-center bg-[#070709] pt-16 px-4">
        <div className="w-full mx-auto px-4 pt-24">
          <div className="flex flex-col gap-8">
            {/* Top Column */}
            <div className="flex flex-col">
              <h1 className="font-calsans text-[36px] font-semibold text-white mb-6 text-left leading-tight">
                BLCKS ist Ihr
                <br />
                Partner für KI-
                <br />
                Transformation
              </h1>
              <a 
                href="https://audit.blcks.at" 
                target="_blank"
                rel="noopener noreferrer"
                className="transition-shadow duration-300 group inline-flex items-center relative justify-center rounded-full tracking-tight h-10 text-16 px-[18px] bg-white text-black font-medium w-fit shadow-[0px_6px_16px_rgba(255,255,255,.2)] hover:shadow-[0px_6px_56px_0px_rgba(255,255,255,.4),0px_4px_15px_0px_rgba(0,0,0,.2)]"
              >
                <span 
                  className="pointer-events-none absolute inset-0 z-0 rounded-[inherit] bg-gradient-to-r from-white to-gray-200 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                  aria-hidden="true"
                />
                <span className="relative z-10">Analyse starten</span>
                <img 
                  src={buttonarrowright} 
                  alt="" 
                  className="relative z-10 ml-1.5 h-5 w-5 shrink-0" 
                  width={16} 
                  height={16} 
                />
              </a>
            </div>

            {/* Bottom Column */}
            <div className="flex flex-col pt-4">
              <p className="font-geist text-[16px] font-normal text-[#787c87] mb-4">
                <span className="text-white font-medium">Unsere Mission:</span> Unternehmen dabei zu unterstützen, Künstliche Intelligenz gezielt und wirkungsvoll einzusetzen. Wir entwickeln Strategien und Lösungen, die Prozesse effizienter machen, Mitarbeiter entlasten und neue Wachstumschancen eröffnen.
              </p>
              <p className="font-geist text-[16px] font-normal text-[#787c87]">
                Wir sind überzeugt, dass KI zu einem <span className="text-white font-medium">zentralen Baustein</span> moderner Unternehmen wird. Unsere Vision ist eine Wirtschaft, in der intelligente Systeme Menschen stärken, Innovation beschleunigen und langfristige Wettbewerbsfähigkeit sichern.
              </p>
            </div>
          </div>
        </div>
        {/* Timeline Container */}
        <div className="w-full mt-20 hidden">
          <div className="relative">
            {/* Upper Timeline Text (Items 2, 4, 6) */}
            <div className="absolute bottom-full left-0 w-full -mb-4">
              {/* Item 2 - 25% from left */}
              <div className="absolute left-[25%] text-left">
                <p className="font-geist text-xs tracking-[0.02em] font-light text-[#787c87]">Juni, 2023</p>
                <p className="font-geist text-base tracking-[0.02em] text-white">KI Durchbruch</p>
              </div>
              
              {/* Item 4 - 50% from left */}
              <div className="absolute left-[50%] text-left">
                <p className="font-geist text-xs tracking-[0.02em] font-light text-[#787c87]">März, 2024</p>
                <p className="font-geist text-base tracking-[0.02em] text-white">Unternehmen testen KI</p>
              </div>
              
              {/* Item 6 - 75% from left */}
              <div className="absolute left-[75%] text-left">
                <p className="font-geist text-xs tracking-[0.02em] font-light text-[#787c87]">September, 2026</p>
                <p className="font-geist text-base tracking-[0.02em] text-white">KI wird zum Standard</p>
              </div>
            </div>

            {/* Timeline Image */}
            <img 
              src={timeline} 
              alt="Timeline" 
              className="w-full h-auto object-contain"
            />

            {/* Lower Timeline Text (Items 1, 3, 5, 7) */}
            <div className="absolute top-full left-0 w-full -mt-16">
              {/* Item 1 - 12.5% from left */}
              <div className="absolute left-[12.5%] text-left">
                <p className="font-geist text-xs tracking-[0.02em] font-light text-[#787c87]">November, 2022</p>
                <p className="font-geist text-base tracking-[0.02em] text-white">ChatGPT Launch</p>
              </div>
              
              {/* Item 3 - 37.5% from left */}
              <div className="absolute left-[37.5%] text-left">
                <p className="font-geist text-xs tracking-[0.02em] font-light text-[#787c87]">Oktober, 2023</p>
                <p className="font-geist text-base tracking-[0.02em] text-white">Erste KI-Produkte</p>
              </div>
              
              {/* Item 5 - 62.5% from left */}
              <div className="absolute left-[62.5%] text-left">
                <p className="font-geist text-xs tracking-[0.02em] font-light text-[#787c87]">September, 2025</p>
                <p className="font-geist text-base tracking-[0.02em] text-white">Jetzt KI integrieren</p>
              </div>
              
              {/* Item 7 - 87.5% from left */}
              <div className="absolute left-[87.5%] text-left">
                <p className="font-geist text-xs tracking-[0.02em] font-light text-[#787c87]">Jänner, 2030</p>
                <p className="font-geist text-base tracking-[0.02em] text-white">KI in jedem Prozess</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Our Mission */}
      <section className="min-h-screen flex items-center justify-center bg-[#070709] py-12 pt-24 px-4">
        <div className="w-full mx-auto px-4 flex flex-col justify-center">
          <h2 className="font-calsans text-[34px] font-semibold text-white mb-8 leading-tight">
            KI als Partner für Ihre Zukunft
          </h2>
          
          <div className="space-y-6 mb-12">
            <p className="text-base text-[#787c87] leading-relaxed">
              <span className="text-white text-font-medium">Die Welt steht an einem Wendepunkt:</span> Künstliche Intelligenz verändert, wie Unternehmen arbeiten, Entscheidungen treffen und wachsen. Doch während die Technologie enorme Möglichkeiten eröffnet, fehlt vielen Organisationen ein klarer Weg, diese Chancen strukturiert und nachhaltig zu nutzen.
            </p>
            <p className="text-base text-[#787c87] leading-relaxed">
              <span className="text-white font-medium">Blcks wurde gegründet,</span> um diese Lücke zu schließen. Wir betrachten KI nicht als Ersatz für Menschen, sondern als Partner, der Teams stärkt und ihre Potenziale multipliziert. Wer Mensch und KI gezielt verbindet, steigert Effizienz, Innovationskraft und langfristigen Geschäftserfolg. Unser Anspruch ist es, Technologie und Business Impact nahtlos miteinander zu verknüpfen.
            </p>
            <p className="text-base text-[#787c87] leading-relaxed">
              <span className="text-white font-medium">Die Zukunft gehört Unternehmen,</span> die KI nicht nur nutzen, sondern in enger Zusammenarbeit mit ihren Teams einsetzen. Blcks begleitet diese Unternehmen, damit KI strategisch Mehrwert schafft, Prozesse optimiert und Innovation vorantreibt. So entsteht nachhaltiges Wachstum, ohne dass der Mensch aus dem Zentrum der Entscheidungen verschwindet.
            </p>
          </div>
          
          <div className="flex flex-col gap-8 mt-8">
            {/* First Stat */}
            <div className="flex-1">
              <div className="text-6xl font-bold font-calsans mb-2 bg-[linear-gradient(73deg,#d5d8f6_1%,#ffffff_50%,#ffffff_100%)] bg-clip-text text-transparent">70%</div>
              <p className="text-[#787c87] text-sm font-light">der Unternehmen weltweit testen oder implementieren bereits KI-Lösungen in ihren Kernprozessen.</p>
            </div>
            
            {/* Second Stat */}
            <div className="flex-1">
              <div className="text-6xl font-bold font-calsans mb-2 bg-[linear-gradient(73deg,#d5d8f6_1%,#ffffff_50%,#ffffff_100%)] bg-clip-text text-transparent">2030</div>
              <p className="text-[#787c87] text-sm font-light">wird KI in den meisten Unternehmen ein unverzichtbarer Bestandteil für Innovation, Effizienz und Wachstum sein.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Our Team */}
      <section className="min-h-screen flex items-center justify-center bg-[#070709] py-20 pt-24 px-4">
        <div className="w-full mx-auto px-4">
          {/* Heading and Description */}
          <div className="text-left mb-12">
            <h2 className="font-calsans text-[34px] font-semibold text-white mb-6">Leadership</h2>
            <p className="font-geist text-base text-[#787c87]">
              Wir sind ein Team aus Gründern und Experten für <span className="text-white font-medium">KI, Automatisierung und Unternehmensentwicklung.</span> Wir glauben an das Potenzial, das entsteht, <br/>wenn Mensch und Maschine zusammenarbeiten.
            </p>
          </div>

          {/* Expanding Team Cards */}
          <ExpandingTeamCard />
        </div>
      </section>

      {/* Section 4: Our Values */}
      <section className="flex items-center justify-center bg-[#070709] py-20 h-auto px-4">
        <div className="w-full mx-auto px-4">
          {/* Heading and Description */}
          <div className="text-center mb-12">
            <h2 className="font-calsans text-[24px] font-medium text-white mb-6">Werte, die uns antreiben und <br/>Partnerschaften erfolgreich machen.</h2>
          </div>

          {/* Value Cards */}
          <div className="grid grid-cols-2 gap-6">
            {/* Value 1 */}
            <div className="rounded-xl p-6 h-auto flex flex-col">
              <div className="w-12 h-12 rounded-lg flex items-center justify-left mb-2">
                <img src={scanSearch} alt="Transparenz" className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Transparenz</h3>
              <p className="text-[#787c87] text-sm">
                Wir setzen auf Klarheit, intern im Team und extern mit unseren Kunden.
              </p>
            </div>

            {/* Value 2 */}
            <div className="rounded-xl p-6 h-auto flex flex-col">
              <div className="w-12 h-12 flex items-center justify-left mb-2">
                <img src={lightbulb} alt="Innovation" className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Innovation</h3>
              <p className="text-[#787c87] text-sm">
                Wir antizipieren die Bedürfnisse von morgen und treiben Innovationen voran.
              </p>
            </div>

            {/* Value 3 */}
            <div className="rounded-xl p-6 h-auto flex flex-col">
              <div className="w-12 h-12 rounded-lg flex items-center justify-left mb-2">
                <img src={handshake} alt="Vertrauen" className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Vertrauen</h3>
              <p className="text-[#787c87] text-sm">
                Vertrauensvolle Partnerschaften stehen im Zentrum unserer Mission.
              </p>
            </div>

            {/* Value 4 */}
            <div className="rounded-xl p-6 h-auto flex flex-col">
              <div className="w-12 h-12 rounded-lg flex items-center justify-left mb-2">
                <img src={rocket} alt="Kundenfokus" className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Kundenfokus</h3>
              <p className="text-[#787c87] text-sm">
                Der Erfolg unserer Kunden steht im Mittelpunkt unseres Handelns.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 5: CTA */}
      <section className="h-auto flex items-center justify-center bg-transparent text-white px-4 py-20 relative overflow-visible">
        {/* Gradient Blur Effect */}
        <div className="absolute inset-0 z-0 pointer-events-none -top-1/4">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-gradient-to-r from-white/10 via-[#d5d8f6]/10 to-white/10 blur-3xl opacity-50"></div>
        </div>
        <div className="absolute inset-0 bg-[#070709] -z-10"></div>
        <div className="relative z-10 text-center">
          <h2 className="font-calsans font-bold text-[30px] tracking-[-0.02em] leading-[1.5] bg-gradient-to-r from-[#d5d8f6] from-30% via-white via-50% to-[#d5d8f6] to-70% bg-clip-text text-transparent text-center mb-8 max-w-[1000px] mx-auto">
            Noch nicht sicher wie <br/> Sie KI einsetzen können?
          </h2>
          <p className="text-[#787c87] text-base mb-8">
            Machen Sie unsere kostenlose KI-Online Audit und entdecken Sie, wie KI Ihr Unternehmen in verschiedenen Bereichen unterstützen kann.
          </p>
          
          <div className="flex flex-row justify-center gap-4">
            <a 
              href="https://audit.blcks.at" 
              target="_blank"
              rel="noopener noreferrer"
              className="transition-shadow duration-300 group inline-flex items-center relative justify-center rounded-full tracking-tight h-10 text-sm px-[18px] bg-white text-black font-medium w-fit mx-auto shadow-[0px_6px_16px_rgba(255,255,255,.2)] hover:shadow-[0px_6px_56px_0px_rgba(255,255,255,.4),0px_4px_15px_0px_rgba(0,0,0,.2)]"
            >
              <span 
                className="pointer-events-none absolute inset-0 z-0 rounded-[inherit] bg-gradient-to-r from-white to-gray-200 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                aria-hidden="true"
              />
              <span className="relative z-10">KI-Online Audit</span>
              <img 
                src={buttonarrowright} 
                alt="" 
                className="relative z-10 ml-1.5 h-5 w-5 shrink-0" 
                width={16} 
                height={16} 
              />
            </a>
            
            <Link 
              to="/contact"
              className="transition-shadow duration-300 group inline-flex items-center relative justify-center rounded-full tracking-tight h-10 text-sm px-[18px] bg-white text-black font-medium w-fit mx-auto shadow-[0px_6px_16px_rgba(255,255,255,.2)] hover:shadow-[0px_6px_56px_0px_rgba(255,255,255,.4),0px_4px_15px_0px_rgba(0,0,0,.2)]"
            >
              <span 
                className="pointer-events-none absolute inset-0 z-0 rounded-[inherit] bg-gradient-to-r from-white to-gray-200 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                aria-hidden="true"
              />
              <span className="relative z-10">Kontaktiere uns</span>
              <img 
                src={buttonarrowright} 
                alt="" 
                className="relative z-10 ml-1.5 h-5 w-5 shrink-0" 
                width={16} 
                height={16} 
              />
            </Link>
          </div>
        </div>
      </section>
      
      {/* Footer */}
      <FooterWrapper />
    </div>
  );
};

export default AboutMobile;